import type { Locale } from '$lib/i18n/types';
import type { ViaMichelinWebTld } from './types';

export const mapLocaleToTld: Record<Locale, ViaMichelinWebTld> = {
	'de-AT': 'at',
	'de-CH': 'ch',
	'de-DE': 'de',
	'en-GB': 'co.uk',
	'en-IE': 'ie',
	'en-US': 'com',
	'es-ES': 'es',
	'fr-BE': 'be',
	'fr-CH': 'ch',
	'fr-FR': 'fr',
	'it-CH': 'ch',
	'it-IT': 'it',
	'nl-BE': 'be',
	'nl-NL': 'nl',
	'pt-PT': 'pt',
};
